import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import DefaultInput from "../../components/form/DefaultInput";
import { useParams } from "react-router-dom";
import api from "../../utils/axios";
import isAuthenticated from "../../utils/isAuthenticated";
import { toast } from "react-toastify";
import classes from "./index.module.css";
import { validatePassword } from "../../utils/passwordValidation";
import useLang from "../../hooks/useLang";

const PasswordResetForm: React.FC = () => {
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [validUUID, setValidUUID] = useState<string>();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const { uuid } = useParams();
	const { strings } = useLang("passwordResetForm");
	const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPassword(e.target.value);
	};

	useEffect(() => {
		if (isAuthenticated()) {
			navigate("/");
		}
		(async () => {
			try {
				const response = await api.get("User/IsValidResetToken", {
					params: { token: uuid },
				});
				if (response.status === 200) {
					setValidUUID(uuid);
				}
			} catch (error) {
				console.error(error);
				navigate("/");
			}
		})();
	}, []);

	const handleChangeConfirmPassword = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		setConfirmPassword(e.target.value);
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setError("");

		if (!validatePassword(password)) {
			toast.error(strings?.messages.error.passwordCriteria);
			setLoading(false);
			return;
		}

		if (password !== confirmPassword) {
			toast.error(strings?.messages.error.passwordsDontMatch);
			setLoading(false);
			return;
		}

		try {
			const response = await api.post("User/UpdateUserPassword", {
				token: validUUID,
				password,
			});
			navigate("/login");
		} catch (error) {
			setError(strings?.messages.error.resetFailed);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<DefaultInput
					type="password"
					label={strings?.components.defaultInputLabels.newPassword}
					value={password}
					onChange={handleChangePassword}
					required
					className={classes.input}
				/>
				<DefaultInput
					type="password"
					label={
						strings?.components.defaultInputLabels.confirmPassword
					}
					value={confirmPassword}
					onChange={handleChangeConfirmPassword}
					required
					className={classes.input}
				/>
				<Button
					disabled={loading}
					onClick={handleSubmit}
					className={classes.button}
				>
					{strings?.components.button}
				</Button>
			</div>
		</div>
	);
};

export default PasswordResetForm;
